import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Avatar, Box, Collapse, IconButton, Link, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { scrollbarStyle } from '../../../shared/dashboard';
import theme from '../../../theme';

type TeamMember = {
	name: string;
	title: string;
	email: string;
	background: string;
	initials: string;
};

const TeamMemberCard: React.FC<{ member: TeamMember }> = ({ member }) => {
    const [isExpanded, setExpanded] = useState<boolean>(false);

    return(
        <Stack direction="row" spacing={1.5}>
            <Avatar sx={{
                width: 48,
                height: 48,
                background: 'linear-gradient(90deg, #2dd4bf 0%, #0d9488 100%)',
                fontWeight: 600,
                fontSize: 16,
            }}> {member.initials} </Avatar>
            <Box flex={1}>
                <Typography fontSize={15} fontWeight={600} color="#2c3e50">
                    {member.name}
                </Typography>
                <Typography fontSize={13} color="#6c757d" fontWeight={600}>
                    {member.title}
                </Typography>
                <Link href={`mailto:${member.email}`} fontSize={13} sx={{ mt: 0.25, display: 'block' }}>
                    {member.email}
                </Link>
                {!!member.background && (
                    <Collapse in={isExpanded} collapsedSize="fit-content"
                        sx={{ width:'100%', height: isExpanded ? '100%' : 'fit-content !important' }}>
                        <Stack direction="row" alignItems="flex-start" justifyContent="space-between" width="100%" height="100%" >
                            <Box sx={{ height: !isExpanded ? '100px' : 'fit-content', overflowY: 'auto', ...scrollbarStyle }}
                                onClick={(e)=>{
                                    e.preventDefault();
                                    setExpanded((prev) => !prev);
                                }}>
                                <Typography fontSize={12} color="#6c757d" sx={{ mt: 0.75, lineHeight: 1.5, whiteSpace: 'pre-line' }}>
                                    {member.background?.replace('- ', '• ')?.replaceAll('\n-', '\n •')}
                                </Typography>
                            </Box>
                            <Stack direction="column" alignItems="center" justifyContent="flex-end" width={24} height="100%">
                                <IconButton onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        setExpanded((prev) => !prev);
                                    }} sx={{ paddingBottom: 'unset'}}
                                    disableRipple>
                                    <ExpandMoreIcon sx={{ width: 24, height: 24,
                                        color: theme.colors.neutral['500'],
                                        transform: `rotate(${isExpanded ? 180 : 0}deg)` }} />
                                </IconButton>
                            </Stack>
                        </Stack>
                    </Collapse>
                )}
            </Box>
        </Stack>
)};

export default TeamMemberCard;